import React, { Suspense, useRef } from 'react';
import useClickOutside from '../../hooks/useClickOutside'; // Corrected path

// 1. Carga diferida (Code Splitting) para el selector de emojis.
// No impacta el tiempo de carga inicial de la página.
const EmojiPicker = React.lazy(() => import('emoji-picker-react'));

const EmojiPickerWrapper = ({ onEmojiClick, onClose }) => {
  const wrapperRef = useRef(null);

  // 2. Hook para cerrar el picker si se hace clic fuera.
  useClickOutside(wrapperRef, onClose);

  return (
    <div ref={wrapperRef} className="absolute z-50 mt-2">
      {/* 3. Suspense muestra un fallback mientras se carga el componente pesado. */}
      <Suspense fallback={<div className="w-80 h-96 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center text-sm text-gray-500">Cargando emojis...</div>}>
        <EmojiPicker
          onEmojiClick={onEmojiClick}
          native // Usar emojis nativos del sistema operativo para máximo rendimiento.
          emojiStyle="native"
          height={400}
          width={320}
        />
      </Suspense>
    </div>
  );
};

export default EmojiPickerWrapper;